var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header',{attrs:{"title":_vm.headerTitle}}),_c('hf-deploy-workspace')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }